import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const RocketIcon = createIcon({
  displayName: 'RocketIcon',
  path: (
    <>
      <path stroke='none' d='M0 0h24v24H0z' />
      <path d='M4 13a8 8 0 0 1 7 7 6 6 0 0 0 3-5 9 9 0 0 0 6-8 3 3 0 0 0-3-3 9 9 0 0 0-8 6 6 6 0 0 0-5 3' />
      <path d='M7 14a6 6 0 0 0-3 6 6 6 0 0 0 6-3m4-8a1 1 0 1 0 2 0 1 1 0 1 0-2 0' />
    </>
  ),
  defaultProps: {
    ...defaultProps,
    fill: 'none',
    stroke: 'currentColor',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeWidth: '2'
  }
})
